import { render, staticRenderFns } from "./button-bubble-br.vue?vue&type=template&id=1f28bc68&scoped=true&"
var script = {}
import style0 from "./button-bubble-br.vue?vue&type=style&index=0&id=1f28bc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f28bc68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f28bc68')) {
      api.createRecord('1f28bc68', component.options)
    } else {
      api.reload('1f28bc68', component.options)
    }
    module.hot.accept("./button-bubble-br.vue?vue&type=template&id=1f28bc68&scoped=true&", function () {
      api.rerender('1f28bc68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-bubble-br.vue"
export default component.exports